import React, { useState } from "react";
import { Fade } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "shared/components/button/CustomButton";
import BodyPanel from "shared/components/panel/BodyPanel";
import FooterPanel from "shared/components/panel/FooterPanel";
import HeaderPanel from "shared/components/panel/HeaderPanel";
import { Panel } from "shared/components/panel/Panel";
import { FaArrowLeft } from "react-icons/fa";
import { useGetConfigAssDigitalCondominioPorUuid } from "hooks/groupsign/useGetConfigAssDigitalCondominioPorUuid";
import { ConfigAssinanteDocumentoDTO } from "types/dto/groupsign/ConfigAssinanteDocumentoDTO";
import { SectionAssDigital } from "./SectionAssDigital";
import { useForm } from "react-hook-form";

export const VisualizarAssinaturasDigitalCondominio: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const configuracaoUuid = location.state as string;
  const { data: registro, refetch } = useGetConfigAssDigitalCondominioPorUuid(configuracaoUuid);

  const [editingSection, setEditingSection] = useState<string | null>(null);
  const [, setPastaPrestacaoContasAtivo] = useState<boolean>(false);
  const [showInputEmail, setShowInputEmail] = useState<boolean>(false);

  const {
    control,
    trigger,
    register,
    setValue,
    watch,
    formState: { errors },
    clearErrors,
  } = useForm({
    mode: "onBlur",
  });

  const handleEdit = (uuid: string) => setEditingSection(uuid);

  const handleVoltar = () => {
    clearErrors();
    if (editingSection) {
      setEditingSection(null);
      setShowInputEmail(false);
      refetch();
    } else {
      navigate(-1);
    }
  };

  const handleConcluir = async () => {
    if (Object.keys(errors).length > 0) {
      return;
    }

    clearErrors();
    setEditingSection(null);
    setShowInputEmail(false);
    refetch();
  };

  const configuracoes = Array.isArray(registro?.configuracaoAssinanteDocumentoResponses)
    ? registro.configuracaoAssinanteDocumentoResponses
    : [];

  const pastaPrestacaoContas = configuracoes.find(
    (config: ConfigAssinanteDocumentoDTO) => config.tipoDocumento === "PASTA_PRESTACAO_CONTAS"
  );
  const updatePastaPrestacaoContasAtivo = (isAtivo: boolean) => setPastaPrestacaoContasAtivo(isAtivo);

  return (
    <Fade in={true} timeout={700}>
      <div>
        <Panel
          headerPanel={
            <HeaderPanel title="Configurações de assinatura digital" ocultarCondominio abaAtual="Configurações" />
          }
          footerPanel={
            <FooterPanel
              title="FooterPanel"
              botoes={[
                <CustomButton
                  className="me-3"
                  key="btnVoltar"
                  id="btnVoltar"
                  variant="warning"
                  leftIcon={FaArrowLeft}
                  label="Voltar"
                  size="sm"
                  onClick={handleVoltar}
                />,
                editingSection && (
                  <CustomButton
                    className="me-5"
                    key="btnConcluir"
                    id="btnConcluir"
                    variant="primary"
                    label="Concluir"
                    size="sm"
                    onClick={handleConcluir}
                  />
                ),
              ].filter(Boolean)}
            />
          }
        >
          <BodyPanel>
            <SectionAssDigital
              title="PASTA DE PRESTAÇÃO DE CONTAS"
              isAtivo={pastaPrestacaoContas?.isAtivo ?? false}
              isEditing={editingSection === "PASTA_PRESTACAO_CONTAS"}
              setIsEditing={() => handleEdit("PASTA_PRESTACAO_CONTAS")}
              config={pastaPrestacaoContas ?? {}}
              configAssDigitalUuid={configuracaoUuid}
              refetch={refetch}
              updateIsAtivo={updatePastaPrestacaoContasAtivo}
              control={control}
              trigger={trigger}
              register={register}
              setValue={setValue}
              watch={watch}
              showInputEmail={showInputEmail}
              setShowInputEmail={setShowInputEmail}
              setEditingSection={setEditingSection}
            />
          </BodyPanel>
        </Panel>
      </div>
    </Fade>
  );
};
